import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleGuard } from '../role.guard';
import { ProfileConst } from '../utils';

const routes: Routes = [
    {
        path: 'terminals',
        loadChildren: () => import('./admin/terminals-admin.module').then(m => m.TerminalsListModule),
        data: { expectedRoles: [ProfileConst.admin_terminal_pf] },
        canActivate: [RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'dispatcher',
        loadChildren: () => import('./dispatcher/dispatcher.module').then(m => m.DispatcherModule),
        data: { expectedRoles: [ProfileConst.dispatcher_pf] },
        canActivate: [RoleGuard],
        runGuardsAndResolvers: 'always'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
    exports: [RouterModule]
})

export class TerminalsRoutingModule { }